<template>
    <div class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50" @click="close">
      <img :src="src" class="max-w-full max-h-full">
    </div>
  </template>
  
  <script>
  export default {
    props: {
      src: {
        type: String,
        required: true
      }
    },
    methods: {
      close() {
        this.$emit('close');
      }
    }
  }
  </script>
  

  